/* eslint-env browser */
const MOUSE_DOWN = 'mousedown';
const WHEEL = 'wheel';

export default (
  checkHoverShow,
  checkClickShow,
  checkTriggerHide,
  checkCloseTrigger
) => ({
  targetWrapper: {
    onClick: checkClickShow,
    onMouseEnter: checkHoverShow,
    onFocus: checkHoverShow,
    onMouseLeave: checkTriggerHide,
    onBlur: checkTriggerHide,
  },
  addOutsideListeners: () => {
    window.addEventListener(MOUSE_DOWN, checkCloseTrigger);
    window.addEventListener(WHEEL, checkCloseTrigger);
  },
  removeOutsideListeners: () => {
    window.removeEventListener(MOUSE_DOWN, checkCloseTrigger);
    window.removeEventListener(WHEEL, checkCloseTrigger);
  },
});
